import { useMemo } from 'react';

import type { PartBotResultJson } from '@frontend/api';

import type { ActionResolution } from 'modules/common/components/findings';

import { useMarkInaccurateActionData } from './MarkInaccurateActionDataContext';

type MarkInaccurateActionProps = {
  printExtractionUuid: string;
};

export const useMarkInaccurateAction = (
  partBotResult: PartBotResultJson | null,
): ActionResolution<MarkInaccurateActionProps> => {
  const { isEnhancedPartbotEnabled } = useMarkInaccurateActionData();

  return useMemo(() => {
    if (!isEnhancedPartbotEnabled || !partBotResult?.uuid) {
      return { enabled: false, printExtractionUuid: '' };
    }

    return {
      enabled: true,
      printExtractionUuid: partBotResult.uuid,
    };
  }, [isEnhancedPartbotEnabled, partBotResult]);
};
